import { hashQuery, omitPagination, stateList } from '@store/utils'
import { filterByQuery } from '@utils'
import { mergeDeepAssign } from '@utils/objects'
import modules from './modules'

// stub getters for each module
const storeModulesWithAutoGetters = Object
  .values(modules)
  .filter(storeModule => storeModule.auto.has('getters'))

const queryShallow = state => filterByQuery(stateList(state), state)
const queryOne = (() => {
  const SINGLE = Object.freeze({ isSingle: true })

  return state => params => filterByQuery(stateList(state), state)(params, SINGLE)
})()

storeModulesWithAutoGetters.forEach((storeModule) => {
  const { storeKey, storeSuffix } = storeModule

  mergeDeepAssign(storeModule, {
    store: {
      getters: {
        [storeKey]: stateList,
        [`${storeKey}Suffix`]: state => state.storeSuffix,
      },
      state: {
        storeSuffix,
        pagination: {},
      },
    },
  })
})

const storeQueries = Object
  .fromEntries(storeModulesWithAutoGetters
    .map(storeModule => [storeModule.storeKey, {
      query: queryShallow,
      queryOne,
    }]))

const queryFactory = queryType => (state, getters) => (storeKey, params, options) =>
  storeQueries[storeKey][queryType](state[storeKey], getters)(params, options)

const getters = {
  getStoreModule: () => storeKey => modules
    .find(storeModule => storeModule.storeKey === storeKey),

  getPageObject: state => (storeKey, { $isForced, ...queryParams }) => {
    return state[storeKey].pages[hashQuery(omitPagination(queryParams))]
  },

  getPageTotal: (_, { getPageObject }) => (storeKey, queryParams) => {
    return getPageObject(storeKey, queryParams)?.total
  },

  getQueryPage: (_, { getPageObject }) => (storeKey, queryParams, skip) => {
    return getPageObject(storeKey, queryParams)?.positions?.[skip]
  },

  // queryWait: (_, getters) => (
  //   storeKey,
  //   queryParams,
  //   options,
  //   attemptsLimit = 20,
  // ) => {
  //   if (!attemptsLimit) {
  //     throw new Error('Could not queryWait for a resource')
  //   }

  //   const result = getters.query(storeKey, queryParams, options)
  //   const isArray = Array.isArray(result)

  //   if ((isArray && result.length) || (!isArray && result)) {
  //     return result
  //   }

  //   // eslint-disable-next-line promise/avoid-new
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(getters.queryWait(storeKey, queryParams, options, attemptsLimit - 1))
  //     }, 100)
  //   })
  // },

  ...Object
    .fromEntries(['query', 'queryOne']
      .map(queryType => [queryType, queryFactory(queryType)])),
}

export default getters
